import React from 'react'
import { CreditRepaymentDataType } from '@shared/components/sections/credit-repayment-methods'
import CalendarInShape from '@shared/svg/in-shape/calendar.svg'
import ClockInShape from '@shared/svg/in-shape/clock.svg'
import DiagramInShape from '@shared/svg/in-shape/diagram.svg'

import styles from './style.module.scss'

export const creditRepaymentMethodsData: CreditRepaymentDataType[] = [
	{
		IconSvg: DiagramInShape,
		title: 'Проблема',
		titleClassName: styles.titleClassName,
		text: 'Клиенту срочно понадобился кредит в марте 2022 года. Ставки в тот период в среднем выросла на 10–12 п.п.',
	},
	{
		IconSvg: ClockInShape,
		title: 'Ситуация клиента',
		titleClassName: styles.titleClassName,
		text: (
			<ul>
				<li>
					– Ставка: <span className={styles.red}>25%&nbsp;годовых.</span>
				</li>
				<li>
					– Платёж в месяц: <span className={styles.red}>60&nbsp;тысяч рублей.</span>
				</li>
			</ul>
		),
	},
	{
		IconSvg: CalendarInShape,
		title: 'Рефинансирование Credit.Club',
		titleClassName: styles.titleClassName,
		text: (
			<ul>
				<li>
					– Снизили ставку <span className={styles.green}>до&nbsp;19% годовых.</span>
				</li>
				<li>
					– Уменьшили платёж <span className={styles.green}>до&nbsp;40&nbsp;тысяч рублей.</span>
				</li>
				<li>
					– Дали дополнительную сумму <span className={styles.green}>350&nbsp;тысяч рублей.</span>
				</li>
			</ul>
		),
	},
]
